import * as am5 from "@amcharts/amcharts5";
import 'bootstrap';
import 'flexmonster/theme/stripedblue/flexmonster.css';
import moment from "moment";
import '../stylesheets/styles.scss';

import { COUNTRY_CODES } from "./config/constants.js";
import { AMCHARTS5_LICENSE } from "./config/global-variables";
import loginModel, { clearCredentials } from './models/login.model';
import navigationModel from "./models/navigation/navigation.model.js";
import apiResponseTimeService from "./service/responseTime.service";

/** Web Fonts */
import "StaticFolder/fonts/google/roboto/roboto.css"; // TODO: Remove later
import "StaticFolder/fonts/samsung/samsungone.css";
import "StaticFolder/fonts/samsung/samsungsharpsans.css";

/** Layouts */
import HomeLayout from "./layout/home.layout";

/** Views */
import AgreementView from "./views/agreement/agreement.view";
import AttendanceView from "./views/attendance/attendance.view";
import ComingSoonView from "./views/coming-soon.view";
import CommonCodeSubsidiaryAdminView from "./views/common-code/common-code-subsidiary-admin.view.js";
import CommonCodeSystemAdminView from "./views/common-code/common-code-system-admin.view.js";
import AnnouncementView from './views/communication/announcement/announcement.view';
import CountryRestrictedView from "./views/country-restricted.view.js";
import DataInputView from './views/data-input/data-input-view';
import DeactivationIMEISelloutView from "./views/deactivation-management/deactivation-imei-sellout.view";
import DeactivationManagementExcelView from './views/deactivation-management/deactivation-management-excel.view';
import DownloadView from "./views/download/download.view";
import FootTrafficView from './views/foot-traffic/foot-traffic.view';
import HomeDashboardView from "./views/home/home-dashboard.view";
import IMEISNLogReportView from './views/imei-sn-log-report/imei-sn-log-report.view';
import IMEISNAnalysisDuplicationSOView from "./views/imei-sn-validation-log/imei-sn-analysis-duplication-so/imei-sn-analysis-duplication-so.view.js";
import ImeiSnAnalysisSoIncreaseStatusView from "./views/imei-sn-validation-log/imei-sn-analysis-so-increase-status.view";
import IMEISerialSalesCheckingView from "./views/insights-and-analytics/IMEI-reports/IMEI-SERIAL-sales-checking.view";
import NewModelDisplayFlooringView from "./views/insights-and-analytics/new-model-display-flooring.view";
import ForgotView from "./views/login/forgot.view";
import LoginView from "./views/login/login.view";
import ResetPasswordView from "./views/login/reset-password.view";
import ResetView from "./views/login/reset.view";
import GlobalHierarchyView from './views/master-data-management/global-hierarchy/global-hierarchy.view';
import MenuHierarchyView from './views/master-data-management/menu-hierarchy/menu-hierarchy.view';
import TaskMasterView from './views/master-data-management/task-management/task-master/task-master.view';
import TaskTemplateView from './views/master-data-management/task-management/task-template/task-template.view';
import TodoManagementView from './views/master-data-management/task-management/to-do/to-do-management.view';
import ModelUDFManagement from './views/master-data-management/udf-management/model-udf-management.view';
import UDFManagementView from './views/master-data-management/udf-management/udf-management.view';
import CustomVisionOverviewView from './views/master/custom-vision/custom-vision.view';
import CVTrainingPerformanceListView from './views/master/custom-vision/cvtrains/custom-vision.performance-list.view';
import CVTrainingSubmissionsListView from './views/master/custom-vision/cvtrains/custom-vision.training-submissions-list.view';
import CustomVisionTrainingView from './views/master/custom-vision/training.view';
import MasterDetailsMainView from "./views/master/master-configuration/master-configuration-main.view";
import UserChannelMappingView from "./views/master/user-channel-mapping/user-channel-mapping.view";
import UserRoleFunctionMapView from './views/master/user-role/user-role-function-map.view';
import UserRoleMenuMapView from './views/master/user-role/user-role-menu-map.view';
import UserProfileView from './views/master/user/profile/user-profile.view';
import UserView from './views/master/user/user.view.js';
import ModelManagementView from './views/model-management/model-management.view';
import ModelUDFDataManagementView from "./views/model-management/model-udf-data-management.view";
import ModelMappingView from "./views/model-mapping/model-mapping.view.js";
import IncentiveSchemeVariableView from "./views/incentive-scheme-variable/incentive-scheme-variable.view";
import IncentiveCalculationView from "./views/incentive-calculation/incentive-calculation.view";
import IncentiveInputView from "./views/incentive-input/incentive-input.view";
import IncentiveReportView from "./views/incentive-report/incentive-report.view";
import IncentiveApprovalView from "./views/incentive-approval/incentive-approval.view";
import MonitoringReportFileContentView from "./views/monitoring-report/file-content/monitoring-report-file-content.view";
import MonitoringReportFileLevelView from "./views/monitoring-report/file-level/file-level.view.js";
import WeeklyEmailSummaryView from "./views/monitoring-report/weekly-email-summary/weekly-email-summary.view";
import PhotoListView from "./views/photo/photo-list.view";
import POSMLevelHierarchy from './views/posm/posm-level-hierarchy.view';
import PurchaseOrderProposalView from "./views/purchase-order-proposal/purchase-order-proposal.view";
import RawDataDownloadView from "./views/raw-data/raw-data-download.view";
import RawDataUploadView from "./views/raw-data/raw-data-upload.view.js";
import ImeiSnInputView from './views/registration/imei-sn-input/imei-sn-input.view';
import RegistrationMultiChannels from './views/registration/multi-channels/multi-channels-excel.view';
import SingleChannelExcel from './views/registration/single-channel-excel/single-channel-excel.view';
import CustomizedReportView from './views/report/customized-report.view';
import MobileReportBuilderView from "./views/report/mobile-report-builder.view.js";
import EdiManagementSiteMappingView from "./views/reports/edi-management-site-mapping/edi-management-site-mapping.view";
import IMEIBasedSuccessRateView from "./views/reports/imei-based-success-rate/imei-based-success-rate.view";
import HHPDistyCoverageView from "./views/reports/psi/hhp-disty-coverage/hhp-disty-coverage.view.js";
import StoreStockoutWithEulaView from "./views/reports/psi/store-stockout-with-eula/store-stockout-with-eula.view";
import SalesReportView from "./views/reports/sales-report/sales-report.view";
import SearchByIMEIView from "./views/reports/search-by-imei/search-by-imei.view";
import SellInInvoiceVsScanCountView from "./views/reports/sell-in-invoice-vs-imei-scan-count/sell-in-invoice-vs-imei-scan-count.view";
import ShopOwnerReportView from "./views/reports/shop-owner/shop-owner-report.view";
import SMECustomerIFModelMapView from "./views/reports/sme-customer-if-model-map/sme-customer-if-model-map.view";
import SAVINADirectInterfaceView from "./views/reports/sms/savina-direct-interface.view";
import SMSLogFSMSavina from "./views/reports/sms/sms-log-fsm/sms-log-fsm-savina.view.js";
import SMSLogView from "./views/reports/sms/sms-log/sms-log.view.js";
import StoreVisitReportView from "./views/reports/store-visit/store-visit-report.view";
import TeamApprovalView from "./views/schedule/team-approval/team-approval.view";
import TeamScheduleView from "./views/schedule/team-schedule/team-schedule.view";
import VisitRateView from "./views/schedule/visit-rate/visit-rate.view";
import WorkTemplateMasterView from './views/schedule/work-templates/work-template-master.view';
import SearchDeleteView from "./views/search-delete/search-delete.view.js";
import SiteManagementView from './views/site-management/site-management.view';
import SiteSoldToShipToMappingView from './views/site-management/site-sold-to-ship-to-mapping/site-sold-to-ship-to-mapping.view';
import SiteSpecialMapping from './views/site-management/site-sold-to-ship-to-special/site-sold-to-ship-to-special.view';
import SMECustomerSiteMapView from "./views/sme-customer-if-site-map/sme-customer-if-site-map.view";
import PublicSurveyView from './views/survey/public/public-survey.view';
import SurveyView from "./views/survey/survey.view";
import DailyBatchCheckView from "./views/system-management/batch-job-management/daily-batch-check/daily-batch-check.view.js";
import BatchJobManagementErrorReportView from "./views/system-management/batch-job-management/error-report/error-report.view.js";
import GSBNMappingManagementView from "./views/system-management/others/gsbn-mapping-management/gsbn-mapping-management.view";
import IMEIExtendedWarranty from "./views/system-management/others/imei-extended-warranty/imei-extended-warranty.view";
import PerformanceView from "./views/task-management/performance/performance.view";
// import TeamOverviewView from "./views/team-management/team.view";
import AgreementCommonView from "./views/agreement/agreement-common.view.js";
import ChatbotView from "./views/chatbot/chatbot.view.js";
import RandomView from './views/communication/randomPing/randomPing.view';
import AdssoMobileLoginSuccessView from "./views/login/adsso/adsso-mobile-login-success.view";
import SamsungAccountAuthSelectUserView from "./views/login/samsung-account/samsung-account-auth-select-user.view.js";
import SamsungAccountMobileLoginSuccessView from "./views/login/samsung-account/samsung-account-mobile-login-success.view.js";
import Messenger from "./views/messenger/messenger.view.js";
import CampaignView from './views/planogram/campaign/campaign.view';
import FixtureView from './views/planogram/fixture/fixture-list.view';
import StoreFixtureMappingView from "./views/planogram/store-fixture-mapping/store-fixture-mapping.view";
import popUpManagementView from "./views/pop-up-management/pop-up-management.view";
import PosmSerialTrackingView from "./views/posm-serial-tracking/posm-serial-tracking.view.js";
import POSMAuthorizationView from "./views/posm/posm-authority.view.js";
import POSMGoodsApproval from "./views/posm/posm-goods-appvoval.view";
import POSMGoodsIssueApplication from "./views/posm/posm-goods-issue-application/posm-goods-issue-application.view.js";
import POSMGoodMasterView from "./views/posm/posm-goods-master-view.js";
import POSMGoodsMovement from "./views/posm/posm-goods-movement.view.js";
import POSMUserMovementWarehouseMappingView from "./views/posm/posm-user-movement-warehouse.view.js";
import { POSMWareHouseManagement } from "./views/posm/posm-warehouse-management.view";
import ReportViewerView from "./views/report/public/report-viewer.view";
import FfCostReportView from "./views/reports/ff-dashboard/ff-cost-report.view";
import FfHeadcountReportView from "./views/reports/ff-dashboard/ff-headcount-report.view";
import FfSelloutReportView from "./views/reports/ff-dashboard/ff-sellout-report.view";
import RetailMappingReportView from "./views/reports/ff-dashboard/retail-mapping-report.view";
import SEAOPOSMGoodsMovement from "./views/retail-asset-management/seao-posm-goods-movement.view.js";
import SEAOPOSMLevelHierarchy from "./views/retail-asset-management/seao-posm-level-hierarchy.view.js";
import SEAOPOSMUserMovementWarehouseMappingView from "./views/retail-asset-management/seao-posm-user-movement-warehouse.view.js";
import SEAOPOSMWareHouseManagement from "./views/retail-asset-management/seao-posm-warehouse-management.view.js";
import SEAOPOSMVendorManagement from "./views/retail-asset-management/seao-vendor-management.view.js";
import PlanActualSummaryView from "./views/schedule/jpo-reports/plan-actual-summary.view.js";
import PlanActualWeeklyMonthly from "./views/schedule/jpo-reports/plan-actual-weekly-monthly.view";
import PlanWorkloadOverview from "./views/schedule/jpo-reports/plan-workload-overview.view";
import JPOScheduleView from "./views/schedule/jpo/jpo-schedule.view.js";
import JPOManualTriggerView from "./views/schedule/manual-trigger/manual-trigger.view.js";
import AIJPOView from "./views/schedule/ai-jpo/ai-jpo.view.js";
import RawDataAccess from './views/system-management/raw-data-access/raw-data-access.view';
import UploadUserManual from "./views/system-management/upload-user-manual/upload-user-manual.view.js";
import TESCOXMLInput from "./views/tesco-xml-input/tesco-xml-input.view";
import Type2PhotoDownloadView from './views/type-2-photo-download/type-2-photo-download.view';
import UnauthorizedView from "./views/unauthorized.view.js";
import ValidationFailOver10PercentView from "./views/validation-fail/validation-fail-over-ten-percent/validation-fail-over-ten-percent.view";
import VocsListView from "./views/voc/voc.list.view";


async function init() {

  function initLibraries() {
    moment.updateLocale('en', {
      week: { dow: 1 }
    });
  }

  function loadWithHomeLayout(view, countryRestriction) {
    return {
      onmatch: function (args, requestedPath) {
        // Redirect to login page if not user is not authenticated
        apiResponseTimeService.setMenuXhrMap(requestedPath);
        if (!loginModel.isAuthenticated()) {
          m.route.set('/login');
          return undefined;
        }

        // Redirect to agreement page if user has not agreed to all agreements
        if (!loginModel.hasAgreedAllAgreements()) {
          m.route.set('/agreement');
          return undefined;
        }

        // Redirect to unauthorized if user does not have access to menu
        if (!navigationModel.canAccessMenuPath(requestedPath)) {
          // Immediately log user out once failed check
          loginModel.logout();
          m.route.set('/unauthorized');
          return undefined;
        }

        // Check if menu is restricted by country
        if (countryRestriction && !countryRestriction.includes(loginModel.credentials.country)) {
          return CountryRestrictedView;
        }

        return view;
      },
      render: (vnode) => {
        return [m(HomeLayout, { key: loginModel.credentials.country }, vnode)];
      }
    };
  }

  function logoutAction() {
    return {
      onmatch: function (_, requestedPath) {
        clearCredentials()
        window.location.href = requestedPath.replace('/logout?signOutURL=', '')
      }
    }
  }

  // Save current route before unload so page refresh restores the user's location
  window.addEventListener('pagehide', () => {
    const route = m.route.get();
    if (route && route !== '/' && route !== '/login') {
      sessionStorage.setItem('mcs_last_route', route);
    }
  });

  initLibraries();

  // Capture the original hash BEFORE checkSession() — the refresh failure handler
  // inside checkSession() may overwrite window.location.hash to /login
  const originalHashRoute = window.location.hash;
  const originalRouteFromHash = originalHashRoute.replace(/^#!?/, '');
  const isSamsungAccountRoute = originalRouteFromHash.startsWith('/samsung-account');
  const isDownloadRoute = originalRouteFromHash.startsWith('/download');

  // Skip session check for Samsung account routes — no MCS session exists yet,
  const sessionValid = (isSamsungAccountRoute || isDownloadRoute) ? false : await loginModel.checkSession();

  if (sessionValid) {
    try { await navigationModel.getActiveMenuList(); } catch { /* non-fatal */ }
    const lastRoute = sessionStorage.getItem('mcs_last_route');
    m.route.set(lastRoute && lastRoute !== '/home' ? lastRoute : '/home');
  } else {
    sessionStorage.removeItem('mcs_last_route');
    navigationModel.clearActiveMenuList();
    if (originalRouteFromHash.startsWith('/login') || 
    originalRouteFromHash.startsWith('/reset-password') || 
    originalRouteFromHash.startsWith('/survey/') || 
    originalRouteFromHash.startsWith('/download') || isSamsungAccountRoute) {
      m.route.set(originalRouteFromHash);
    } else {
      m.route.set('/login');
    }
  }

  /* ----- Routing ----- */
  m.route(document.getElementById("root"), "/", {
    "/": LoginView,
    "/login": LoginView,
    "/samsung-account/users": SamsungAccountAuthSelectUserView,
    "/forgot": ForgotView,
    "/reset": loadWithHomeLayout(ResetView),
    "/home": loadWithHomeLayout(HomeDashboardView),
    "/reset-password": ResetPasswordView,
    "/coming-soon": loadWithHomeLayout(ComingSoonView), // Due to security concerns, this is not used in production
    "/unauthorized": UnauthorizedView,
    "/logout": logoutAction(),
    "/samsung-account-mobile-login-success": SamsungAccountMobileLoginSuccessView,
    "/adsso-mobile-login-success": AdssoMobileLoginSuccessView,

    /** AGREEMENT */
    "/agreement": AgreementView,
    "/agreement/:agreementType": AgreementCommonView,
    "/agreement/:agreementType/:subsidiary": AgreementCommonView,

    /** DOWNLOAD PAGE */
    "/download": DownloadView,

    /** TASK MANAGEMENT */
    "/schedule/visit-rate": loadWithHomeLayout(VisitRateView),
    "/schedule/team-schedule": loadWithHomeLayout(TeamScheduleView),
    "/schedule/approval": loadWithHomeLayout(TeamApprovalView),
    "/schedule/work-templates": loadWithHomeLayout(WorkTemplateMasterView),
    "/schedule/plan-actual-summary": loadWithHomeLayout(PlanActualSummaryView),
    "/schedule/plan-actual-weekly-monthly": loadWithHomeLayout(PlanActualWeeklyMonthly),
    "/schedule/workload-overview": loadWithHomeLayout(PlanWorkloadOverview),
    "/schedule/route-plan": loadWithHomeLayout(JPOScheduleView),
    "/schedule/manual-trigger": loadWithHomeLayout(JPOManualTriggerView),
    "/schedule/ai-jpo": loadWithHomeLayout(AIJPOView),

    /** INSIGHTS & ANALYTICS */
    "/performance": loadWithHomeLayout(PerformanceView),
    "/new-model-display-flooring": loadWithHomeLayout(NewModelDisplayFlooringView),
    "/imei-serial-sales-checking": loadWithHomeLayout(IMEISerialSalesCheckingView),

    /** PHOTO */
    "/photo": loadWithHomeLayout(PhotoListView),

    /** MASTER DATA MANAGEMENT */
    "/user": loadWithHomeLayout(UserView),
    "/custom-vision": loadWithHomeLayout(CustomVisionOverviewView),
    //"/custom-vision/:projectId":  loadWithHomeLayoutAndParam(CustomVisionOverviewView),
    "/custom-vision-training": loadWithHomeLayout(CustomVisionTrainingView),
    "/custom-vision-submissions": loadWithHomeLayout(CVTrainingSubmissionsListView),
    "/custom-vision-performance": loadWithHomeLayout(CVTrainingPerformanceListView),
    "/udf-management": loadWithHomeLayout(UDFManagementView),
    "/announcement": loadWithHomeLayout(AnnouncementView),
    "/random-ping": loadWithHomeLayout(RandomView),
    "/task-master": loadWithHomeLayout(TaskMasterView),
    "/task-template": loadWithHomeLayout(TaskTemplateView),
    "/to-do": loadWithHomeLayout(TodoManagementView),
    "/attendance": loadWithHomeLayout(AttendanceView),
    '/user-profile': loadWithHomeLayout(UserProfileView),
    // "/teams": loadWithHomeLayout(TeamOverviewView),

    /** REPORTS */
    "/customized-report/:dataSourceCode": loadWithHomeLayout(CustomizedReportView),
    "/customized-report/:dataSourceCode/:msa": loadWithHomeLayout(CustomizedReportView),
    "/imei-based-success-rate-report": loadWithHomeLayout(IMEIBasedSuccessRateView),
    "/mobile-report-builder": loadWithHomeLayout(MobileReportBuilderView),
    "/sme-customer-if-model-mapping": loadWithHomeLayout(SMECustomerIFModelMapView),
    "/edi-management-site-mapping": loadWithHomeLayout(EdiManagementSiteMappingView),
    "/savina-direct-interface": loadWithHomeLayout(SAVINADirectInterfaceView, [COUNTRY_CODES.VIETNAM]),
    "/search-by-imei": loadWithHomeLayout(SearchByIMEIView),
    "/sell-in-invoice-vs-imei-scan-count": loadWithHomeLayout(SellInInvoiceVsScanCountView),
    "/store-stockout-with-eula": loadWithHomeLayout(StoreStockoutWithEulaView),
    "/ff-headcount-report/:calc": loadWithHomeLayout(FfHeadcountReportView),
    "/ff-sellout-report/:calc": loadWithHomeLayout(FfSelloutReportView),
    "/ff-cost-report/:calc": loadWithHomeLayout(FfCostReportView),
    "/retail-mapping-report/:calc": loadWithHomeLayout(RetailMappingReportView),

    "/ff-headcount-report": loadWithHomeLayout(FfHeadcountReportView),
    "/ff-sellout-report": loadWithHomeLayout(FfSelloutReportView),
    "/ff-cost-report": loadWithHomeLayout(FfCostReportView),
    "/retail-mapping-report": loadWithHomeLayout(RetailMappingReportView),

    /** SURVEY */
    "/survey": loadWithHomeLayout(SurveyView),

    /** PURCHASE ORDER */
    "/purchase-order-proposal": loadWithHomeLayout(PurchaseOrderProposalView),

    /**  GLOBAL HIERARCHY */
    "/global-hierarchy": loadWithHomeLayout(GlobalHierarchyView),
    "/menu-hierarchy": loadWithHomeLayout(MenuHierarchyView),
    "/common-code": loadWithHomeLayout(CommonCodeSystemAdminView), // For system admin
    "/country-common-code": loadWithHomeLayout(CommonCodeSubsidiaryAdminView), // For subidiary admin

    /** VOC */
    "/voc": loadWithHomeLayout(VocsListView),
    "/master-configuration": loadWithHomeLayout(MasterDetailsMainView),

    /** Planogram */
    "/image": loadWithHomeLayout(FixtureView),
    "/store-mapping": loadWithHomeLayout(StoreFixtureMappingView),
    "/campaign": loadWithHomeLayout(CampaignView),

    /** Temporary Page -  */
    "/type-2-photo-download": loadWithHomeLayout(Type2PhotoDownloadView),

    /** PUBLIC */
    "/survey/:publicSurveyGuid/public": PublicSurveyView,
    "/report/:reportGuid": ReportViewerView,

    /** DATA INPUT */
    "/data-input": loadWithHomeLayout(DataInputView),

    /** FOOT TRAFFIC */
    "/foot-traffic": loadWithHomeLayout(FootTrafficView),

    /** USER ROLE */
    "/user-role-function-map": loadWithHomeLayout(UserRoleFunctionMapView),
    "/user-role-menu-map": loadWithHomeLayout(UserRoleMenuMapView),

    /** DEACTIVATION MANAGEMENT */
    "/deactivation-via-excel-upload": loadWithHomeLayout(DeactivationManagementExcelView),
    "/deactivation-imei-sn-sell-out": loadWithHomeLayout(DeactivationIMEISelloutView),

    /** MODEL UDF MANAGEMENT */
    "/model-udf-management": loadWithHomeLayout(ModelUDFManagement),

    /** REGISTRATION */
    '/registration-web': loadWithHomeLayout(ImeiSnInputView),
    '/registration-excel-single-channel': loadWithHomeLayout(SingleChannelExcel),
    "/registration-excel-multi-channel": loadWithHomeLayout(RegistrationMultiChannels),

    /** SITE MANAGEMENT */
    "/site-management": loadWithHomeLayout(SiteManagementView),
    "/site-sold-to-mapping": loadWithHomeLayout(SiteSoldToShipToMappingView),
    "/rep-sold-to-mapping": loadWithHomeLayout(SiteSpecialMapping),

    /**MODEL MANAGEMENT */
    '/model-management': loadWithHomeLayout(ModelManagementView),
    '/model-udf-data-management': loadWithHomeLayout(ModelUDFDataManagementView),

    /** USER CHANNEL MAPPING */
    '/user-channel-mapping': loadWithHomeLayout(UserChannelMappingView),

    /** TESCO XML */
    '/tesco-xml': loadWithHomeLayout(TESCOXMLInput),

    /** RAW DATA */
    '/raw-data-download': loadWithHomeLayout(RawDataDownloadView),
    '/raw-data-upload': loadWithHomeLayout(RawDataUploadView),

    /** SEARCH-DELETE */
    '/search-delete': loadWithHomeLayout(SearchDeleteView),

    /**IMEI EXTENDED WARRANTY */
    '/imei-extended-warranty': loadWithHomeLayout(IMEIExtendedWarranty),

    /** INCENTIVE - FFIS SCHEME CONFIGURATION */
    '/incentive-scheme-variable': loadWithHomeLayout(IncentiveSchemeVariableView),

    /** INCENTIVE - FFIS CALCULATION (menu WM021103, OPERATOR).
        The path must be BYTE-IDENTICAL to MenuMaster.path or the menu cannot resolve and the
        page is unreachable however correct it is. */
    '/incentive-calculation': loadWithHomeLayout(IncentiveCalculationView),

    /** INCENTIVE - FFIS INPUTS & UPLOADS (menu WM021102, OPERATOR). */
    '/incentive-input': loadWithHomeLayout(IncentiveInputView),

    /** INCENTIVE - FFIS REPORTS (menu WM021105, APPROVER). */
    '/incentive-report': loadWithHomeLayout(IncentiveReportView),

    /** INCENTIVE - FFIS APPROVAL (menu WM021104, APPROVER).
        WM021104 must NOT be granted to the same role as WM021103 (Calculation), or whoever
        runs the payout calculation also approves it. */
    '/incentive-approval': loadWithHomeLayout(IncentiveApprovalView),

    /** GSBN MAPPING MANAGEMENT */
    '/gsbn-mapping': loadWithHomeLayout(GSBNMappingManagementView),

    /** SME CUSTOMER I/F SITE MAP */
    '/sme-customer-if-site-map': loadWithHomeLayout(SMECustomerSiteMapView),

    /** SMS Log */
    '/sms-log': loadWithHomeLayout(SMSLogView, [COUNTRY_CODES.VIETNAM, COUNTRY_CODES.MALAYSIA]),

    /** SAVINA SMS LOG FSM */
    '/savina-sms-log-fsm': loadWithHomeLayout(SMSLogFSMSavina, [COUNTRY_CODES.VIETNAM]),

    /** WEEKLY EMAIL SUMMARY */
    '/monitoring-report-weekly-email-summary': loadWithHomeLayout(WeeklyEmailSummaryView),

    /** MODEL MAPPING */
    '/intf-edi-model-mapping': loadWithHomeLayout(ModelMappingView),

    /** EDI MANAGEMENT */
    '/monitoring-report-file-content': loadWithHomeLayout(MonitoringReportFileContentView),

    /** WEB MONITORING REPORT FILE LEVEL */
    "/monitoring-report-file-level": loadWithHomeLayout(MonitoringReportFileLevelView),

    /** DAILY BATCH CHECK */
    "/batch-job-mgmt-daily-batch-check": loadWithHomeLayout(DailyBatchCheckView),

    /** Batch Job Management - Error Report */
    '/batch-job-mgmt-error-report': loadWithHomeLayout(BatchJobManagementErrorReportView),

    /** System management - row data access */
    '/raw-data-access': loadWithHomeLayout(RawDataAccess),

    /** SHOP OWNER REPORT */
    "/shop-owner-report": loadWithHomeLayout(ShopOwnerReportView),

    /** IMEI/SN Log Report*/
    "/imei-sn-log-report": loadWithHomeLayout(IMEISNLogReportView),

    /** SALES REPORT */
    '/sales-report': loadWithHomeLayout(SalesReportView),

    /** HHP Disty Coverage */
    '/hhp-disty-coverage': loadWithHomeLayout(HHPDistyCoverageView),

    /**Imei Validation fail over 10% */
    '/imei-validation-fail-over-10-percent': loadWithHomeLayout(ValidationFailOver10PercentView),

    /** IMEI/SN ANALYSIS - DUPLICATION S/O */
    '/imei-sn-analysis-duplication-so': loadWithHomeLayout(IMEISNAnalysisDuplicationSOView),

    /** IMEI S/N ANALYSIS S/O INCREASE STATUS VIEW */
    '/imei-sn-analysis-so-increase-status': loadWithHomeLayout(ImeiSnAnalysisSoIncreaseStatusView),

    /** Store Visit Report */
    '/store-visit-report': loadWithHomeLayout(StoreVisitReportView),

    /** Pop-up Management */
    '/pop-up-management': loadWithHomeLayout(popUpManagementView),

    /** UPLOAD USER MANUAL */
    '/upload-user-manual': loadWithHomeLayout(UploadUserManual),

    "/posm/serial-no-report": loadWithHomeLayout(PosmSerialTrackingView),
    /** POSM AUTHORIZATION */
    '/posm-authorization': loadWithHomeLayout(POSMAuthorizationView),

    '/posm-goods-movement': loadWithHomeLayout(POSMGoodsMovement),

    '/posm-global-hierarchy': loadWithHomeLayout(POSMLevelHierarchy),

    '/posm-good-master': loadWithHomeLayout(POSMGoodMasterView),

    '/posm-user-movement-warehouse': loadWithHomeLayout(POSMUserMovementWarehouseMappingView),
    '/posm-warehouse-management': loadWithHomeLayout(POSMWareHouseManagement),
    /** POSM Goods Issue Application */
    '/posm-goods-issue-application': loadWithHomeLayout(POSMGoodsIssueApplication),

    '/posm-goods-approval': loadWithHomeLayout(POSMGoodsApproval),

    /** SEAO POSM features */
    '/seao/posm-goods-movement': loadWithHomeLayout(SEAOPOSMGoodsMovement),
    '/seao/posm-global-hierarchy': loadWithHomeLayout(SEAOPOSMLevelHierarchy),
    '/seao/posm-user-movement-warehouse': loadWithHomeLayout(SEAOPOSMUserMovementWarehouseMappingView),
    '/seao/posm-warehouse-management': loadWithHomeLayout(SEAOPOSMWareHouseManagement),
    '/seao/posm-vendor-management': loadWithHomeLayout(SEAOPOSMVendorManagement),

    /**Messenger */
    '/messenger': loadWithHomeLayout(Messenger),

    /** AI CHATBOT */
    '/chatbot': loadWithHomeLayout(ChatbotView)

  });

  // Add amCharts 5 license
  am5.addLicense(AMCHARTS5_LICENSE);
}

window.onload = init;
